export default (position) => {
  const calc = Math.floor(position.x / (window.innerWidth / 20)) + 1
  return calc < 10 ? 180 - (10 - calc) : 180 + calc - 10
}
